import { Layout, Content, ContentArea } from "elseware-ui";
import GenericLayout from "../GenericLayout";

import { CustomHeader, CustomFooter } from "../../../components";

function DefaultLayout({ children }) {
  return (
    <GenericLayout>
      <Layout>
        {/* Header */}
        <CustomHeader />

        {/* Content */}
        <Content styles="pt-[60px]">
          <ContentArea enablePadding>{children}</ContentArea>
        </Content>

        {/* Footer */}
        <CustomFooter />
      </Layout>
    </GenericLayout>
  );
}

export default DefaultLayout;
